import { isRtl } from '@/common/utils/i18n'
import { Button, Tag } from '@roo/roo'
import { useTranslation } from '@sailor/i18n-web'
import React from 'react'
import { useNavigate } from 'react-router'

const Home = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  return (
    <div className="page-content" style={{ padding: '12px 24px' }}>
      <h2>{t('e_pc_welcome', '欢迎!')}</h2>
      <h4>{t('e_pc_provide_meal_allowance', '通过Keeta企业版为员工提供餐饮津贴')}</h4>
      <div style={{ height: '550px',  display: 'flex' }}>
        <div style={{ width: '400px', height: '100%', border: '1px solid #f5f5f5', borderRadius: '8px', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
          <div style={{
            height: '310px',
            width: '100%',
            borderRadius: '8px',
            backgroundImage: 'url(https://img-ap-hongkong.mykeeta.net/sailorcweb/cbbb929860be84c5f71f7b01f059993f110494.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'bottom',
          }}></div>
          <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', flex: 1,  justifyContent: 'space-between' }}>
            <div >
              <h2>{t('e_pc_set_meal_allowance', '为员工安排餐饮津贴')}</h2>
              <Tag color="#ffe608">{t('e_pc_staff_welfare', '员工福利')}</Tag>
              <ul style={{ transform: 'translateX(10px)', paddingTop: '10px', fontWeight: 600 }}>
                <li style={{ listStyle: isRtl ? 'inside' : 'outside' }}>{t('e_pc_staff_use_allowance', '员工使用津贴支付餐费')}</li>
                <li style={{ listStyle: isRtl ?  'inside' : 'outside' }}>{t('e_pc_insufficient_balance_pay', '当津贴额度不足时使用组合支付')}</li>
              </ul>
            </div>
            <Button type="brand"  onClick={() => navigate('/rule')} style={{ width: '100%' }}>{t('e_pc_view_rule_manage', '查看规则管理')} </Button>
          </div>
        </div>
        <div style={{ width: '20px' }}></div>
        <div style={{
          flex: 1, height: '100%',
          borderRadius: '8px',
          backgroundImage: 'url(https://img-ap-hongkong.mykeeta.net/sailorcweb/dd8b1105656757fee76af1b604b76786700707.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}></div>
      </div>
    </div>
  )
}
export default Home